export function ListItem({
  buttonImg,
  buttonOnClick,
  text,
  textOnClick,
  style = {},
}) {
  return (
    <div className="list-item">
      <div className="list-item-button" onClick={buttonOnClick}>
        <img src={buttonImg} alt="no alt text available, sorry" />
      </div>
      <div className="list-item-text" onClick={textOnClick} style={style}>
        {text}
      </div>
    </div>
  );
}
